import React, { useEffect, useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import Image from "../../Components/Reusable/Image";
import { PngImages, SvgImages } from "../../Utils/LocalImages";
import SubmitButton from "../../Components/Reusable/Buttons";
import { Swiper, SwiperSlide } from "swiper/react";
import { ImageFilters } from "../../Utils/Enums";
import CarouselCircular from "../../Components/Carousel/Carousel";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { Pagination } from "swiper/modules";
import { Link } from "react-router-dom";
import RoutesPath from "../../Utils/RoutesPath";
import HomeBannerModal from "../../modal/HomeBannerModal";
import ApiService from "../../Services/ApiService";
import ApiConstants from "../../Utils/ApiConstant";
import { handleApiErrors } from "../../Utils/Utils";

const Home = () => {
  const [showBannerModal, setShowBannerModal] = useState(true);

  const [sliderData, setSliderData] = useState();
  const [testimonials, setTestimonials] = useState([]);

  const ensureArrayLength = (arr, desiredLength = 45) => {
    const currentLength = arr.length;

    if (currentLength === desiredLength) {
      return arr;
    }

    if (currentLength > desiredLength) {
      // Truncate the array to the desired length
      return arr.slice(0, desiredLength);
    }

    // Duplicate elements until the array reaches the desired length
    const result = [...arr];
    let index = 0;

    while (result.length < desiredLength) {
      result.push(arr[index % currentLength]);
      index++;
    }

    return result;
  };

  const getHomeData = async () => {
    try {
      const response = await ApiService.getHomeData();
      setSliderData(response.sliderData);
      setTestimonials(ensureArrayLength(response.testimonials));
    } catch (error) {
      handleApiErrors(error);
    }
  };

  useEffect(() => {
    getHomeData();
  }, []);

  return (
    <div className="d-flex flex-column">
      {/* Image Banner Carousel */}
      <Carousel interval={3000} controls={false}>
        <Carousel.Item>
          <div className="w-100 banner d-flex align-items-center justify-content-between gap-4">
            <div className="d-flex flex-column gap-4 align-items-start">
              <h2 className="Banner-title headingColor mb-0 fw-600">
                {sliderData?.sliderOneTitle}
              </h2>
              <p className="Banner-description subTextColor mb-0">
                {sliderData?.sliderOneDescription}
              </p>
              <Link
                to={sliderData?.sliderOneLink ?? ""}
                target="_blank"
                rel="noopener noreferrer"
              >
                <SubmitButton title={sliderData?.sliderOneButtonTitle} />
              </Link>
            </div>
            <Image
              className="desktopBanner h-100"
              style={{ objectFit: "contain" }}
              src={ApiConstants.FILE_FETCH_URL + sliderData?.sliderOneImage}
            />
          </div>
        </Carousel.Item>

        <Carousel.Item>
          <div className="w-100 banner d-flex align-items-center justify-content-between gap-4">
            <div className="d-flex flex-column mb-4 align-items-start">
              <h2 className="Banner-title headingColor mb-3 fw-600">
                {sliderData?.sliderTwoTitle}
              </h2>
              <p className="Banner-description subTextColor mb-3">
                {sliderData?.sliderTwoDescription}
              </p>
              <Link
                to={sliderData?.sliderTwoLink ?? ""}
                target="_blank"
                rel="noopener noreferrer"
              >
                <SubmitButton title={sliderData?.sliderTwoButtonTitle} />
              </Link>
            </div>
            <Image
              className="desktopBanner h-100"
              style={{ objectFit: "contain" }}
              src={ApiConstants.FILE_FETCH_URL + sliderData?.sliderTwoImage}
            />
          </div>
        </Carousel.Item>

        <Carousel.Item>
          <div className="w-100 banner d-flex align-items-center justify-content-between gap-4">
            <div className="d-flex flex-column mb-4 align-items-start">
              <h2 className="Banner-title headingColor mb-3 fw-600">
                {sliderData?.sliderThreeTitle}
              </h2>
              <p className="Banner-description subTextColor mb-3">
                {sliderData?.sliderThreeDescription}
              </p>
              <Link
                to={sliderData?.sliderThreeLink ?? ""}
                target="_blank"
                rel="noopener noreferrer"
              >
                <SubmitButton title={sliderData?.sliderThreeButtonTitle} />
              </Link>
            </div>
            <Image
              className="desktopBanner h-100"
              style={{ objectFit: "contain" }}
              src={ApiConstants.FILE_FETCH_URL + sliderData?.sliderThreeImage}
            />
          </div>
        </Carousel.Item>
      </Carousel>

      {/* Journey Card */}
      <JourneySection />

      {/* USP Display Section */}
      <div className="w-100 greyBackground p-4">
        <div className="d-flex flex-column text-center mb-4">
          <h3 className="Sub-Heading black mb-2">USP's</h3>
          <h2 className="Heading headingColor mb-0 fw-600">
            What makes us Unique
          </h2>
        </div>

        <Swiper
          className="mb-3 container pb-5"
          pagination={{
            clickable: true,
            bulletActiveClass: "swiperActiveBullet",
          }}
          modules={[Pagination]}
          slidesPerView={4}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            575: {
              slidesPerView: 2,
            },
            992: {
              slidesPerView: 3,
            },
            1200: {
              slidesPerView: 4,
            },
          }}
          spaceBetween={48}
        >
          <SwiperSlide>
            <USPCard
              image={SvgImages.uspOne}
              heading={"Empowering Students"}
              subHeading={
                "At Learn and Achieve is dedicated to enhancing the educational experience of students  across India."
              }
              index={"01"}
              primaryColor={"#00458A"}
              secondaryColor={"#136DC8"}
              hoverTagFilter={ImageFilters.uspCardOne}
            />
          </SwiperSlide>

          <SwiperSlide>
            <USPCard
              image={SvgImages.uspTwo}
              heading={"Charting Your Path"}
              subHeading={
                "The journey to a successful career can be daunting, especially for students navigating the  transition from school to work."
              }
              index={"02"}
              primaryColor={"#F6821F"}
              secondaryColor={"#FFBD85"}
              hoverTagFilter={ImageFilters.uspCardTwo}
            />
          </SwiperSlide>

          <SwiperSlide>
            <USPCard
              image={SvgImages.uspThree}
              heading={"Supporting Every Learner"}
              subHeading={
                "We believe in an inclusive education system, and that's why Learn and Achieve offers  free special education and remedial services."
              }
              index={"03"}
              primaryColor={"#8519D9"}
              secondaryColor={"#AF71DF"}
              hoverTagFilter={ImageFilters.uspCardThree}
            />
          </SwiperSlide>

          <SwiperSlide>
            <USPCard
              image={SvgImages.uspFour}
              heading={"Aim High"}
              subHeading={
                "Success in competitive examinations can open doors to various opportunities."
              }
              index={"04"}
              primaryColor={"#007C27"}
              secondaryColor={"#15C04B"}
              hoverTagFilter={ImageFilters.uspCardFour}
            />
          </SwiperSlide>
        </Swiper>
      </div>

      {/* Student Girl Banner */}
      <div className="student-girl-banner">
        <Image
          className="student-girl-banner-vector"
          src={SvgImages.studentGirlVectorGraphics}
        />
        <div
          className="student-girl-banner-container d-flex flex-column justify-content-center w-100 p-4"
          style={{ marginRight: -48 }}
        >
          <h2 className="Heading black mb-0 fw-600">
            Get a jump on your studies!
          </h2>
          <p className="medium-text subTextColor mb-0 text-start mt-2">
            Sign up for the Bharat SAT exam and the Learn and Achieve Study App
            with mock tests. This will help you:
          </p>
          <div className="d-flex gap-2 align-items-center mt-3 Studentgirlbannercontent">
            <Image src={SvgImages.checkmarkright} />
            <p className="mb-0 medium-text subTextColor mb-0">
              Do well in school from a young age: By practicing with the app and
              taking the Bharat SAT exam, you'll build a strong foundation for
              your learning.
            </p>
          </div>
          <div className="d-flex gap-2 align-items-center mt-3 Studentgirlbannercontent">
            <Image src={SvgImages.checkmarkright} />
            <p className="mb-0 medium-text subTextColor mb-0 ">
              Make learning fun and engaging: The app offers a variety of
              activities and tests that will keep you interested in your
              studies.
            </p>
          </div>
          <Link to={RoutesPath.studentRegistration}>
            <div className="d-flex justify-content-start">
              <SubmitButton style={{ marginTop: 16 }} title={"Get Started Now"} />
            </div>
          </Link>
        </div>
        <div className="position-relative student-girl-image-group h-100">
          <Image
            className="student-girl-background-vector"
            src={SvgImages.uspCardHoverTag}
          />
          <Image className="student-girl-image" src={PngImages.studentGirl} />
        </div>
      </div>

      {/* Testimonials */}
      {/* {testimonials && testimonials.length > 0 ?
                <div className='d-flex flex-column testimonial-container gap-3'>
                    <div className='d-flex flex-column gap-2 container p-0 align-items-center mt-4 px-4 w-100'>
                        <h2 className='Heading headingColor mb-0 fw-600 text-center'>What Our Student Feedback</h2>
                        <p className='medium-text subTextColor mb-0 text-center'>Learn and Achieve is dedicated to enhancing the educational experience of students across India.</p>
                    </div>

                    <div className='overflow-hidden'>
                        <CarouselCircular data={testimonials}/>
                    </div>
                </div>
                : null
            } */}

      {/* Download the App */}
      <div className="w-100 greyBackground p-4">
        <div className="d-flex flex-column gap-5 container">
          <div className="d-flex flex-column text-center mt-4 mb-5">
            <h3 className="Sub-Heading black mb-2">Download the App Now!</h3>
            <h2 className="Heading headingColor mb-2 fw-600">
              Learn & Achieve – Master Exams & Win Rewards!
            </h2>
            <p className="Sub-Heading subTextColor mb-0">
              Crack exams with expert study material, mock tests & Bharat SAT—win exciting prizes!
            </p>
          </div>

          <div className="download-app-card row align-items-center gx-4 p-4 mt-5 position-relative">
            <div className="col-md-6">
              <div className="download-app-phone-container mb-5">
                <Image
                  className="download-app-phone-image"
                  src={PngImages.downloadAppPhone}
                />

                <div className="download-qr-mobile d-flex flex-column gap-2 align-items-center justify-content-center">
                  <div className="box-curved-padding align-self-center p-1">
                    <Image
                      className="download-app-qr-image"
                      src={PngImages.downloadAppQr}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="download-app-content-box d-flex flex-column">
                <h2 className="Heading white fw-600 mb-3">
                  Download Learn & Achieve – Your Path to Success!
                </h2>
                <h3 className="Sub-Heading white fw-400">
                  Practice mock tests, access top study material & crack Bharat SAT with amazing rewards!
                </h3>
                <div className="download-app-qr-buttons d-flex align-items-end mt-3 gap-3">
                  <div className="download-qr-desktop d-flex gap-3 align-items-end">
                    <div className="box-curved-padding p-1">
                      <Image
                        className="download-app-qr-image"
                        src={PngImages.downloadAppQr}
                      />
                    </div>


                  </div>

                  <div className="download-app-store-buttons flex-wrap d-flex gap-3 align-items-center">
                    <Link to={"https://play.google.com/store/search?q=learn+and+achieve&c=apps&hl=en"} target="_blank" rel="noopener noreferrer">
                      <div className="box-curved-padding d-flex gap-2 align-items-center cursor-pointer">
                        <Image
                          src={SvgImages.androidIcon}
                          style={{ height: 28 }}
                        />
                        <div className="d-flex flex-column">
                          <h3 className="Caption black fw-400 mb-0">
                            Get it on
                          </h3>
                          <h2 className="medium-text black fw-600 mb-0">
                            Play Store
                          </h2>
                        </div>
                      </div>
                    </Link>

                    <h3 className="medium-text white fw-400 mb-0">OR</h3>

                    <div className="box-curved-padding d-flex gap-2 align-items-center user-select-none">
                      <Image src={SvgImages.iOSIcon} style={{ height: 28 }} />
                      <div className="d-flex flex-column">
                        <h3 className="Caption black fw-400 mb-0">
                          Coming Soon
                        </h3>
                        <h2 className="medium-text black fw-600 mb-0">
                          App Store
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <HomeBannerModal
        showModal={showBannerModal}
        setShowModal={setShowBannerModal}
      /> */}
    </div>
  );
};

export default Home;

function USPCard({
  image,
  primaryColor,
  secondaryColor,
  heading,
  subHeading,
  index,
  hoverTagFilter = ImageFilters.uspCardOne,
}) {
  return (
    <div className="usp-card-parent">
      <div className="usp-card position-relative">
        <div className="d-flex flex-column w-100">
          <div className="d-flex flex-column mx-3 mt-4 mb-2">
            <Image className="usp-image" src={image} />
            <h3 className="Sub-Heading fw-600 black mb-2 mt-3">{heading}</h3>
            <h4 className="subTextColor small-text fw-400 mb-0">
              {subHeading}
            </h4>
          </div>
          <Image
            className="usp-card-hover-tag"
            src={SvgImages.uspCardHoverTag}
            style={{ width: 44, filter: hoverTagFilter.filter }}
          />
        </div>

        <div
          className="usp-card-line"
          style={{ backgroundColor: secondaryColor }}
        >
          <div>
            <h3
              className="Sub-Heading fw-600 white m-0 w-100 text-center p-3"
              style={{ backgroundColor: primaryColor, lineHeight: "unset" }}
            >
              {index}
            </h3>
          </div>
        </div>
      </div>
    </div>
  );
}

function JourneySection() {
  return (
    <div className="Section container">
      <div className="journey-section-container row">
        <div className="journey-mobile-view text-center">
          <h3 className="Sub-Heading black mb-2">Learn About Us</h3>
          <h2 className="Heading headingColor mb-3 fw-600">
            Join Us on the Journey
          </h2>
          <p className="Sub-Heading subTextColor mb-0">
            Learn and Achieve is dedicated to enhancing the educational
            experience of students across India. We invite you to join us on
            this remarkable journey to build a brighter future for the next
            generation.
          </p>
        </div>

        <div className="col-md-6 d-flex align-items-center justify-content-center">
          <Image className="journey-image" src={PngImages.journey} />
        </div>

        <div className="col-md-6 p-0">
          <div className="journey-desktop-view mb-4">
            <h3 className="Sub-Heading black mb-2">Learn About Us</h3>
            <h2 className="Heading headingColor mb-3 fw-600">
              Join Us on the Journey
            </h2>
            <p className="Sub-Heading subTextColor mb-0">
              Learn and Achieve is dedicated to enhancing the educational
              experience of students across India. We invite you to join us on
              this remarkable journey to build a brighter future for the next
              generation.
            </p>
          </div>

          <div className="journey-card-group d-flex flex-column gap-4">
            <div className="Journey-card col-md-12 col-10">
              <div className="journeyCardIconBackground">
                <Image
                  src={SvgImages.journeyCardOneIcon}
                  style={{ width: 35, aspectRation: 1 }}
                />
              </div>
              <h4 className="mb-0 large-text fw-600">
                Building Strong Educational Foundations
              </h4>
            </div>

            <div className="Journey-card col-md-12 col-10">
              <div className="journeyCardIconBackground">
                <Image
                  src={SvgImages.journeyCardTwoIcon}
                  style={{ width: 35, aspectRation: 1 }}
                />
              </div>
              <h4 className="mb-0 large-text fw-600">
                Empowering the Next Generation
              </h4>
            </div>

            <div className="Journey-card col-md-12 col-10">
              <div className="journeyCardIconBackground">
                <Image
                  src={SvgImages.journeyCardThreeIcon}
                  style={{ width: 35, aspectRation: 1 }}
                />
              </div>
              <h4 className="mb-0 large-text fw-600">
                Bharat SAT: A Path to Success
              </h4>
            </div>
          </div>

          <div className="d-flex journey-learn-more-btn mt-4">
            <Link to={RoutesPath.aboutUs}>
              <SubmitButton title={"Learn More"} />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
